import * as React from 'react';
import { ShoppingCartContext, RFPContainer, WSAppContext } from '@weddingspot/ws-core-components';
import { logEvent, AnalyticsEvent } from '@weddingspot/ws-analytics';

interface HotelRFPContainerProps {
    rfpModalShowing: boolean;
    setRfpModalShowing: (showing: boolean) => void;
}

export const HotelRFPContainer = (props: HotelRFPContainerProps) => {
    const { rfpModalShowing, setRfpModalShowing } = props;
    const shoppingCartContext = React.useContext(ShoppingCartContext);
    const { user } = React.useContext(WSAppContext);

    const onSubmitRFP = (count: number) => {
        shoppingCartContext.resetCart();
        logEvent(AnalyticsEvent.EVTNM_SUBMIT_RFP, { source: 'hotel blocks SRP', 'Number of hotels': count });
    };

    const onSubmitRoomCount = (params: Object) => {
        logEvent(AnalyticsEvent.EVTNM_SUBMITTED_ROOM_COUNT, params);
    };

    const onClickSpecifyGuestRooms = () => {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_SPECIFY_GUEST_ROOMS, { Source: 'hotel blocks SRP' });
    };

    const previewData = shoppingCartContext.items.map((i) => ({
        id: i.id as string,
        meta: {
            name: i.name,
            location: i.location,
            previewImg: i.imageUrl,
            rating: i.rating,
        },
    }));

    return (
        <>
            {rfpModalShowing && (
                <RFPContainer
                    show={rfpModalShowing}
                    onHide={() => setRfpModalShowing(false)}
                    csnVenueData={previewData}
                    defaultFormValue={user || undefined}
                    handleHotelsRecommendedForm={onSubmitRFP}
                    handleRoomCountSubmit={onSubmitRoomCount}
                    handleClickedSpecifyGuestRooms={onClickSpecifyGuestRooms}
                    leadSource='room blocks search'
                />
            )}
        </>
    );
};
